import classNames from "classnames";
import moment from "moment";
import React from "react";
import {
	EBFL2RecordState,
	TBFL2BackendRecord,
	TBFL2Record,
} from "../../../../redux/app/bfl-2/@types";
import { marpolUtils } from "../../../../redux/app/marpol";
import Biofouling2TableRows from "./BioTableRows";
import getSignTableRows from "./getSignTableRows";
type OwnProps = {
	isSubmitterChiefOrMaster: boolean;
	biofoulingRecord: TBFL2BackendRecord;
};
type Biofouling2RecordParticipantsViewProps = OwnProps;
function Biofouling2RecordParticipantsView(
	props: Biofouling2RecordParticipantsViewProps
) {
	const { biofoulingRecord } = props;

	return (
		<Biofouling2TableRows
			record={biofoulingRecord}
			tableRows={getSignTableRows(biofoulingRecord)}
		/>
	);
}

export default Biofouling2RecordParticipantsView;
